import { render, staticRenderFns } from "./DialogAddLectureStudent.vue?vue&type=template&id=6b63cc76&scoped=true"
import script from "./DialogAddLectureStudent.vue?vue&type=script&lang=js"
export * from "./DialogAddLectureStudent.vue?vue&type=script&lang=js"
import style0 from "./DialogAddLectureStudent.vue?vue&type=style&index=0&id=6b63cc76&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b63cc76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b63cc76')) {
      api.createRecord('6b63cc76', component.options)
    } else {
      api.reload('6b63cc76', component.options)
    }
    module.hot.accept("./DialogAddLectureStudent.vue?vue&type=template&id=6b63cc76&scoped=true", function () {
      api.rerender('6b63cc76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddLectureStudent.vue"
export default component.exports